<template>
  <div class="min-h-screen bg-gray-900">
    <!-- Hero Section -->
    <section class="relative py-20 bg-gradient-to-b from-primary-600 to-primary-700 text-white">
      <div class="container mx-auto px-4">
        <div class="max-w-3xl mx-auto text-center">
          <h1 class="text-4xl md:text-5xl font-bold text-white mb-6" data-aos="fade-up">
            {{ $t('gallery.hero.title') }}
          </h1>
          <p class="text-xl text-primary-100" data-aos="fade-up" data-aos-delay="100">
            {{ $t('gallery.hero.subtitle') }}
          </p>
        </div>
      </div>
    </section>

    <!-- Gallery Grid -->
    <section class="py-20">
      <div class="container mx-auto px-4">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <!-- Gallery Item 1 -->
          <div class="group relative overflow-hidden rounded-lg shadow-lg" data-aos="fade-up">
            <img src="https://picsum.photos/seed/gallery1/800/600" alt="Gallery Image" class="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110" />
            <div class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <button class="text-white text-lg font-medium">{{ $t('gallery.viewDetails') }}</button>
            </div>
          </div>

          <!-- Gallery Item 2 -->
          <div class="group relative overflow-hidden rounded-lg shadow-lg" data-aos="fade-up" data-aos-delay="100">
            <img src="https://picsum.photos/seed/gallery2/800/600" alt="Gallery Image" class="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110" />
            <div class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <button class="text-white text-lg font-medium">{{ $t('gallery.viewDetails') }}</button>
            </div>
          </div>

          <!-- Gallery Item 3 -->
          <div class="group relative overflow-hidden rounded-lg shadow-lg" data-aos="fade-up" data-aos-delay="200">
            <img src="https://picsum.photos/seed/gallery3/800/600" alt="Gallery Image" class="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110" />
            <div class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <button class="text-white text-lg font-medium">{{ $t('gallery.viewDetails') }}</button>
            </div>
          </div>

          <!-- Gallery Item 4 -->
          <div class="group relative overflow-hidden rounded-lg shadow-lg" data-aos="fade-up">
            <img src="https://picsum.photos/seed/gallery4/800/600" alt="Gallery Image" class="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110" />
            <div class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <button class="text-white text-lg font-medium">{{ $t('gallery.viewDetails') }}</button>
            </div>
          </div>

          <!-- Gallery Item 5 -->
          <div class="group relative overflow-hidden rounded-lg shadow-lg" data-aos="fade-up" data-aos-delay="100">
            <img src="https://picsum.photos/seed/gallery5/800/600" alt="Gallery Image" class="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110" />
            <div class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <button class="text-white text-lg font-medium">{{ $t('gallery.viewDetails') }}</button>
            </div>
          </div>

          <!-- Gallery Item 6 -->
          <div class="group relative overflow-hidden rounded-lg shadow-lg" data-aos="fade-up" data-aos-delay="200">
            <img src="https://picsum.photos/seed/gallery6/800/600" alt="Gallery Image" class="w-full h-64 object-cover transition-transform duration-300 group-hover:scale-110" />
            <div class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              <button class="text-white text-lg font-medium">{{ $t('gallery.viewDetails') }}</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import AOS from 'aos'
import 'aos/dist/aos.css'

onMounted(() => {
  AOS.init({
    duration: 800,
    easing: 'ease-in-out',
    once: true
  })
})
</script>

<style scoped>
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--primary-600), var(--primary-700));
}
</style>

